import axiosInstance from "./AxiosInstance";

export const getTelecallerLeadsService = (payload) => {
  return axiosInstance.post(
      "lead/getLeadsWithAppointmentButNoForm",
      payload
    );
  };


  export const getUnreceivedCallLeadsService = (payload) => {
    return axiosInstance.post(
      "lead/getUnreceivedCallLeads",
      payload
    );
  };

  export const routeToServiceCallerService = (payload) => {
    return axiosInstance.post("/lead/routeToServicecaller", payload);
  };